import { render } from "./SurfGame.vue?vue&type=template&id=3eb119b6&scoped=true&ts=true"
import script from "./SurfGame.vue?vue&type=script&lang=ts"
export * from "./SurfGame.vue?vue&type=script&lang=ts"

import "./SurfGame.vue?vue&type=style&index=0&id=3eb119b6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3eb119b6"]])

export default __exports__